import { Link, useLocation } from 'react-router';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/hooks';
import { ThemeToggle } from "@/components/common/ThemeToggle";
import { MobileNav } from "@/components/layout/MobileNav";
import Logo from "@/components/common/Logo";

interface NavigationProps {
  showAuth?: boolean;
  className?: string;
}

export const Navigation = ({ showAuth = true, className = "" }: NavigationProps) => {
  const { user } = useAuth();
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className={`flex items-center justify-between p-4 w-full max-w-7xl mx-auto ${className}`}>
      <Link to="/" className="inline-flex items-center gap-3">
        <Logo className="h-9 w-auto" />
        <span className="sr-only">Arcitext</span>
      </Link>

      {/* Main Navigation Links */}
      <div className="hidden lg:flex items-center gap-8">
        {!user && (
          <>
            <Link
              to="/"
              className={`text-sm font-medium transition-colors ${isActive('/') ? 'text-primary' : 'text-muted-foreground hover:text-primary'
                }`}
            >
              Home
            </Link>
            <Link
              to="/for-creators"
              className={`text-sm font-medium transition-colors ${isActive('/for-creators') ? 'text-primary' : 'text-muted-foreground hover:text-primary'
                }`}
            >
              For Creators
            </Link>
            <Link
              to="/for-professionals"
              className={`text-sm font-medium transition-colors ${isActive('/for-professionals') ? 'text-primary' : 'text-muted-foreground hover:text-primary'
                }`}
            >
              For Professionals
            </Link>
          </>
        )}
        <Link
          to="/features"
          className={`text-sm font-medium transition-colors ${isActive('/features') ? 'text-primary' : 'text-muted-foreground hover:text-primary'
            }`}
        >
          Features
        </Link>
        <Link
          to="/pricing"
          className={`text-sm font-medium transition-colors ${isActive('/pricing') ? 'text-primary' : 'text-muted-foreground hover:text-primary'
            }`}
        >
          Pricing
        </Link>
      </div>

      {/* Mobile: CTA + Menu Toggle */}
      <div className="flex items-center gap-2 lg:hidden">
        {showAuth && !user && (
          <Link to="/?auth=signup">
            <Button size="sm" variant="outline">Sign Up / In</Button>
          </Link>
        )}
        {showAuth && user && (
          <Link to="/app">
            <Button variant="ghost" size="sm">Dashboard</Button>
          </Link>
        )}
        <MobileNav showAuth={showAuth} />
      </div>

      {/* Desktop: Theme Toggle + Full CTA */}
      <div className="hidden lg:flex items-center gap-2">
        <ThemeToggle />
        {showAuth && !user && (
          <Link to="/?auth=signup">
            <Button variant="outline">Sign Up / In</Button>
          </Link>
        )}
        {showAuth && user && (
          <Link to="/app">
            <Button variant="ghost">Go to Dashboard</Button>
          </Link>
        )}
      </div>
    </nav>
  );
};
